import roundN from './roundN.js';

/**
 * format seconds to minutes and seconds 90s -> 1m 30s, 120s -> 2m
 * @param seconds - The number of seconds to format
 * @returns A string representing the formatted time
 */
const formatSecondsToMinutesAndSeconds = (seconds: number): string => {
    const roundedSeconds = roundN(seconds, 0);
    if (roundedSeconds < 60) {
        return `${roundedSeconds}s`;
    }

    const minutes = Math.floor(roundedSeconds / 60);
    const remainingSeconds = roundedSeconds % 60;

    if (remainingSeconds === 0) {
        return `${minutes}m`;
    }

    return `${minutes}m ${roundN(remainingSeconds, 0)}s`;
};

export default formatSecondsToMinutesAndSeconds;
